import React from 'react'
// import Lottie from 'react-lottie'
import { useQuery } from 'react-query'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { getFetchRequest } from '@/root/utils/network-adapter/fetch-request'

const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

type Props = {
  autoWidthHeight?: boolean
  lottie?: string
  speed?: number
  loop?: boolean | number | undefined
  autoplay?: boolean
  height?: number | string
  width?: number | string
  preserveAspectRatio?: string
  className?: string
  eventListeners?
  options?: {
    autoplay?: boolean
  }
}

const LottieControl = ({ props }: { props: Props }) => {
  const lottieRQData = useQuery(
    [`lottiefile`, props.lottie],
    () =>
      getFetchRequest({
        url: props.lottie ?? '',
      }),
    {
      retry: 1,
      enabled: !!props.lottie,
    },
  )

  const { autoWidthHeight = false } = props

  if (!lottieRQData.data) return null

  const defaultOptions = {
    animationData: lottieRQData.data,
    rendererSettings: {
      preserveAspectRatio: props.preserveAspectRatio ?? 'xMidYMid meet',
    },
    loop: props.loop,
    autoplay: true,
    ...props.options,
  }

  const conditionalProps: Pick<Props, 'width' | 'height'> = {}

  if (!autoWidthHeight) {
    conditionalProps.width = props.width
    conditionalProps.height = props.height
  }

  return (
    <div className={classNames('my-4', props.className)}>
      <Lottie
        options={defaultOptions}
        speed={props.speed ?? 1}
        eventListeners={props.eventListeners}
        {...conditionalProps}
      />
    </div>
  )
}

export default LottieControl
